import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { type ContentLanguage, type LangCode } from '@@lib/i18n/constants';

import { type TeamListSearchParams } from './teamListSearchParams';

const PAGE_SIZE = 50;

type Languages = { contentLocale: ContentLanguage; uiLocale: LangCode };

export const teamListQuery = (
    team: { sportType: 'soccer' | 'iceHockey' | 'tennis'; paramSort: string },
    search: TeamListSearchParams,
    { contentLocale, uiLocale }: Languages,
) =>
    client.liveticker.teams.getAll.infiniteQueryOptions({
        query: {
            sportType: team.sportType,
            sort: team.paramSort,
            q: search.q,
            leagueIds: search.leagueIds,
            size: PAGE_SIZE,
            ...(search.q ? { locale: uiLocale } : null),
        },
        headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
    });

export const leagueListQuery = (q: string | undefined, { contentLocale, uiLocale }: Languages) =>
    client.liveticker.leagues.getAll.infiniteQueryOptions({
        query: {
            sportTypes: 'soccer,iceHockey',
            size: PAGE_SIZE,
            q,
            ...(q ? { locale: uiLocale } : null),
        },
        headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
    });
